import React from 'react';
import { connect } from 'react-redux';
import { Avatar } from '@material-ui/core';
import Api from '../../api/Api.js';
import { store } from '../../redux/store';
import { SET_PRODUCT_LIST } from '../../redux/types';
import { push } from 'connected-react-router';
import ProductEndpoints from '../../api/ProductEndpoints';
import ProductImage from '../../components/Image/ProductImage';
import DataTable from '../../components/Table/DataTable';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Logo",
        options: {
            filter: false,
            sort: false,
            download: false
        }
    },
    {
        name: "Product Name",
        options: {
            filter: true,
            sort: true,
        }
    }
];



class SearchProducts extends React.Component {

    options = {
        onRowClick: (row) => store.dispatch(push('/products/view/' + row[0]))
    };

    UNSAFE_componentWillMount() {
        Api.get(ProductEndpoints.list).then(({ data }) => store.dispatch({ type: SET_PRODUCT_LIST, payload: data })).catch((e) => console.error(e));
    }

    render() {
        return (
                <DataTable
                    title={"Search Products"}
                    data={
                        this.props.products
                        .map(prod => [prod.id, <Avatar><ProductImage image={prod.image} /></Avatar>, prod.name])
                    }
                    columns={columns}
                    options={this.options}
                />
        );
    }
}

const mapStateToProps = (state) => ({ products: state.products.list })

export default connect(mapStateToProps)(SearchProducts);